import { render, staticRenderFns } from "./SetupBase.vue?vue&type=template&id=7b206248&"
import script from "./SetupBase.vue?vue&type=script&lang=ts&"
export * from "./SetupBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports